"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable react/require-default-props, import/no-cycle */
var react_1 = __importStar(require("react"));
var antd_1 = require("antd");
var icons_1 = require("@ant-design/icons");
var moment_1 = __importDefault(require("moment"));
var Async_1 = __importDefault(require("../../../../../Table/Async"));
var Button_1 = __importDefault(require("../../../../../Form/Elements/Button"));
var TextInput_1 = __importDefault(require("../../../../../Form/Elements/TextInput"));
var Inquery_1 = __importDefault(require("../../../../../Drawer/Drawers/Inquery"));
var InquiriesTable = function (_a) {
    var query = _a.query, activeProjects = _a.activeProjects, add = _a.add, inquiryDrawerQueryVariablesFormatter = _a.inquiryDrawerQueryVariablesFormatter, inquiryDrawerQueryVariables = _a.inquiryDrawerQueryVariables, inquiryDrawerQuery = _a.inquiryDrawerQuery;
    var _b = react_1.useState(""), searchString = _b[0], setSearchString = _b[1];
    var _c = react_1.useState([]), selectedRows = _c[0], setSelectedRows = _c[1];
    var _d = react_1.useState([]), selectedRowKeys = _d[0], setSelectedRowKeys = _d[1];
    var _e = react_1.useState(""), drawer = _e[0], setDrawer = _e[1];
    var columns = [
        {
            title: "Deadline",
            dataIndex: ["node", "deadline"],
            key: "deadline",
            sorter: {
                compare: function (a, b) {
                    return a.node.deadline.localeCompare(b.node.deadline);
                },
                multiple: 3,
            },
            render: function (text, record) { return (react_1.default.createElement("span", null, moment_1.default(text).format("LLL"))); },
        },
        {
            title: "Waste Volume",
            dataIndex: ["node", "wasteVolume"],
            key: "wasteVolume",
            sorter: {
                compare: function (a, b) {
                    return a.node.wasteVolume.localeCompare(b.node.wasteVolume);
                },
                multiple: 3,
            },
        },
        {
            title: "Issue Type",
            dataIndex: ["node", "issueType"],
            key: "issueType",
            sorter: {
                compare: function (a, b) {
                    return a.node.issueType.localeCompare(b.node.issueType);
                },
                multiple: 3,
            },
        },
        {
            title: "",
            key: "action",
            render: function (text, record) { return (react_1.default.createElement(antd_1.Space, { size: "middle" },
                react_1.default.createElement(Button_1.default, { title: "View", size: "small", onClick: function () { return setDrawer(record.node.id); } }))); },
        },
    ];
    var tableProps = {
        antdTableProps: {
            rowKey: function (record) { return record.node.id; },
            columns: columns,
            rowSelection: {
                selectedRowKeys: selectedRowKeys,
                type: "checkbox",
                onChange: function (sRowKeys, sRows) {
                    setSelectedRows(sRows);
                    setSelectedRowKeys(sRowKeys);
                },
            },
        },
    };
    var handleAdd = function () {
        add(selectedRows);
        setSelectedRows([]);
        setSelectedRowKeys([]);
    };
    var queryResultFormatter = function (values) {
        return (values === null || values === void 0 ? void 0 : values.allInquiries.edges) || [];
    };
    var queryVariablesFormatter = function (queryVariables) {
        return __assign({}, queryVariables);
    };
    var queryVariables = {
        activeProjects: activeProjects,
    };
    // eslint-disable-next-line @typescript-eslint/ban-types
    var dataSourceFilter = function (dataSource) {
        if (searchString) {
            return dataSource.filter(function (row) {
                return row.node.id.includes(searchString);
            });
        }
        return dataSource;
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { style: { padding: "1rem" } }, selectedRows.length > 0 ? (react_1.default.createElement(Button_1.default, { onClick: handleAdd, title: "Add to route (" + selectedRows.length + ")" })) : (react_1.default.createElement(TextInput_1.default, { value: searchString, onChange: function (e) { return setSearchString(e.currentTarget.value); }, prefix: react_1.default.createElement(icons_1.SearchOutlined, null), placeholder: "Search" }))),
        react_1.default.createElement(Async_1.default, { query: query, queryResultFormatter: queryResultFormatter, queryVariablesFormatter: queryVariablesFormatter, queryVariables: queryVariables, tableProps: tableProps, dataSourceFilter: dataSourceFilter }),
        react_1.default.createElement(Inquery_1.default, { visible: !!drawer, onClose: function () { return setDrawer(""); }, query: inquiryDrawerQuery, queryVariables: __assign(__assign({}, inquiryDrawerQueryVariables), { id: drawer }), queryVariablesFormatter: inquiryDrawerQueryVariablesFormatter })));
};
exports.default = InquiriesTable;
